import React from 'react';
import { imageLinks } from 'assets/images';
import "./TypingIndicator.scss";

const TypingIndicator: React.FC = () => {
    return (
        <div className="message__bubble agent" data-testid="typing-indicator">
            <div className="row">
                <div className="col-2">
                    <div className="sender__image">
                        <img src={imageLinks.logo} alt="AI"/>
                    </div>
                </div>
                <div className="">
                    <div className="message__bubble--group typing">
                        <div className="message__bubble--group--text typing-indicator">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TypingIndicator;
